// Shared invitation enums (see Expert Invitation feature notes).

export const InvitationStatusEnum = Object.freeze({
  Pending: 1,
  Accepted: 2,
  Revoked: 3,
});

export const InvitationStatusLabels = {
  [InvitationStatusEnum.Pending]: "Pending",
  [InvitationStatusEnum.Accepted]: "Accepted",
  [InvitationStatusEnum.Revoked]: "Revoked",
};

// Badge/Tag color words (AntD accepts these color words).
export const InvitationStatusColors = {
  [InvitationStatusEnum.Pending]: "gold",
  [InvitationStatusEnum.Accepted]: "green",
  [InvitationStatusEnum.Revoked]: "red",
};

export const InvitationSourceEnum = Object.freeze({
  Admin: 1,
  Manager: 2,
  SuperAdmin: 3,
});
